export default (axios) => async (oauthSignature, clientSid) => {
  const url = `/v2/clients/${encodeURIComponent(clientSid)}/excursion-types`;

  const axiosConfig = {
    method: 'GET',
    url,
    params: {
      'oauth-signature': oauthSignature
    }
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
